import { Directive, ElementRef, HostListener, inject, type OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventBusService } from '@big-direkt/event-bus';
import { ExternalLinkService } from '../services/external-link.service';
import { PlatformService } from '../services/platform.service';

@Directive({
    selector: '[bigSharedComputeInnerHtmlLinks]',
})
export class ComputeInnerHtmlLinksDirective implements OnInit {
    private readonly elementRef = inject(ElementRef<HTMLAnchorElement>);
    private readonly eventBus = inject(EventBusService);
    private readonly externalLinkService = inject(ExternalLinkService);
    private readonly platformService = inject(PlatformService);
    private readonly router = inject(Router);

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        const element: HTMLElement = event.target as HTMLElement;

        if (element.tagName !== 'A') {
            return;
        }

        const href: string | null = element.getAttribute('href');

        // eslint-disable-next-line no-null/no-null
        if (href === null) {
            return;
        }

        this.eventBus.emit({ key: 'page_navigation_event', data: { triggerElement: element, targetUrl: href } });

        if (this.externalLinkService.isExternal(href)) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.router.navigate([href]).catch((): void => {
        });
        event.preventDefault();
    }

    public ngOnInit(): void {
        if (this.platformService.isPlatformServer()) {
            return;
        }

        const links: NodeListOf<HTMLAnchorElement> = this.elementRef.nativeElement.querySelectorAll('a');

        links.forEach((a: HTMLAnchorElement): void => {
            const isExternal: boolean = this.externalLinkService.isExternal(a.href);

            a.setAttribute('rel', this.externalLinkService.getRel(isExternal));
            a.setAttribute('target', this.externalLinkService.getTarget(isExternal));
        });
    }
}
